import React, { useState, useEffect, useCallback } from 'react';
import { Dropdown } from 'primereact/dropdown';
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { useCatchResponse } from '../../utils/useCatchResponse';
import moment from 'moment';

const AcademicYearSelector = (props) => {
    const { catchResponse } = useCatchResponse();

    const [userId, setUserId] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [financialYears, setFinancialYears] = useState([]);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setUserId(loginData?._id);
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const startYear = currentMonth >= 4 ? currentYear : currentYear - 1;

        const years = [];
        for (let i = 0; i < 7; i++) {
            const year = startYear - i;
            years.push({ label: `${year}-${year + 1}`, value: `${year}-${year + 1}` });
        }
        getFinancialYear(loginData?._id);
    }, []);

    const loadCurrentFinancialYear = async (id, dataList) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const startYear = currentMonth >= 4 ? currentYear : currentYear - 1;
        const endYear = startYear + 1;
        const financialYear = `${startYear}-${endYear}`;
        const filterData = dataList?.find((y) => y?.label === financialYear);
        setSelectedYear(filterData?.value);
        // await updateFinancialYear(id, filterData?.value);
    }

    const handleYearChange = useCallback(async (e) => {
        setSelectedYear(e.value);
        await updateFinancialYear(userId, e.value);
    }, [])

    const getFinancialYear = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (res?.data) {
                        const filterData = res?.data?.flatMap(y =>
                            y?.CalendarValue?.map(x => ({
                                label: `${moment(x?.StartDate).format("YYYY")}-${moment(x?.EndDate).format("YYYY")}`,
                                value: x?._id
                            }))
                        );
                        setFinancialYears(filterData);
                        loadCurrentFinancialYear(userId, filterData);
                    }
                } else {
                    await loadCurrentFinancialYear(userId, []);
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (error) {
            console.log("Error get Financial Year: ", error);
            catchResponse(error);
        }
    }

    const updateFinancialYear = async (userId, year) => {
        try {
            const payloads = {
                UserID: userId,
                FinancialYear: year
            }
            await api.post(APIConstant.path.updateFinancialYear, payloads).then(async (res) => {
                if (res.success) {
                    await getFinancialYear(userId);
                }
                setTimeout(() => {
                    window.location.reload();
                }, 2000)
            }).catch(err => {
                console.log("Error Update Financial Year: ", err);
                catchResponse(err);
            });
        } catch (error) {
            console.log("Error Update Financial Year: ", error);
            catchResponse(error);

        }
    }

    return (
        <div className="e-select-year">
            <Dropdown
                className="p-w-100 p-mt-1"
                name='selectedYear'
                inputId='selectedYear'
                value={selectedYear}
                options={financialYears}
                onChange={handleYearChange}
                placeholder="Select Academic Year"
                filter
            />
        </div>
    );
};

export default AcademicYearSelector;